import { Directive, ElementRef, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appFormError]',
})
export class FormErrorDirective {
  private _errors: ValidationErrors | null | undefined;

  @Input() set errors(value: ValidationErrors | null | undefined) {
    this._errors = value;
    this.setErrorMessage();
  }

  private errorMessages: Record<string, string> = {
    required: 'Este campo es obligatorio.',
    email: 'El formato del correo no es válido.',
    minlength: 'El texto es demasiado corto.',
    maxlength: 'El texto es demasiado largo.',
    pattern: 'El formato ingresado no es válido.',
    itemTaken: 'Ya existe un registro con este valor.',
    fechaInvalida: 'La fecha final no puede ser anterior a la fecha inicial.',
    // Mensajes de error para validación de contraseña
    noUpperCase: 'La contraseña debe contener al menos una letra mayúscula.',
    noLowerCase: 'La contraseña debe contener al menos una letra minúscula.',
    noNumbers: 'La contraseña debe contener al menos un número.',
    hasConsecutiveNumbers: 'La contraseña no puede contener números consecutivos.',
    noSpecialChar: 'La contraseña debe contener al menos un carácter especial (!@#$%^&*()_+-=[]{};\':"\\|,.<>/?).'
  };

  constructor(private el: ElementRef) {}

  private setErrorMessage(): void {
    if (!this._errors) {
      this.el.nativeElement.innerText = '';
      return;
    }

    const errorKeys = Object.keys(this._errors);
    if (errorKeys.length > 0) {
      this.el.nativeElement.innerText = this.errorMessages[errorKeys[0]] || 'Error desconocido';
    }
  }
}
